import { Link } from "react-router-dom";
import type { AnyContent } from "@/lib/content";
import { contentLink } from "@/lib/content";
import { formatViews } from "@/lib/format";

export default function HotRanking({ items }: { items: AnyContent[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-fill text-primary-500" />
          热门内容榜
        </h2>
        <span className="font-label text-[10px] tracking-widest text-foreground-400">前十名</span>
      </div>

      <ol className="divide-y divide-background-100 px-4">
        {items.map((item, index) => (
          <li key={`${item.type}-${item.id}`}>
            <Link
              to={contentLink(item)}
              className="group flex cursor-pointer items-start gap-3 py-3"
            >
              <span
                className={[
                  "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-sm font-label text-[11px] font-bold",
                  index < 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-500",
                ].join(" ")}
              >
                {index + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-[13px] leading-snug text-foreground-800 transition-colors group-hover:text-primary-600 line-clamp-2">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-400">
                  <i className="ri-eye-line" />
                  {formatViews(item.views)}
                  <span className="text-foreground-200">·</span>
                  <span className="truncate">{item.type === "news" ? "资讯" : item.type === "movie" ? "影视" : "综艺"}</span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}